var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0417 10.6665C10.3369 10.6665 8.1417 12.8966 8.1417 15.6443C8.1417 18.3921 10.3369 20.6221 13.0417 20.6221C15.7465 20.6221 17.9417 18.3921 17.9417 15.6443C17.9417 12.8966 15.7465 10.6665 13.0417 10.6665ZM14.6587 17.9839L12.5517 15.8434V12.6576H13.5317V15.4352L15.3447 17.277L14.6587 17.9839Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01318 9.7565L2.01318 5.0565L8.01318 2.8065L14.0132 5.0565L14.0132 8.7465C14.7232 8.8465 15.3932 9.0565 16.0132 9.3465V3.6665L8.01318 0.666504L0.0131836 3.6665L0.0131836 9.7565C0.0131836 14.8065 3.42318 19.5165 8.01318 20.6665C8.04318 20.6565 8.06318 20.6465 8.09318 20.6465C7.30318 19.8665 6.69318 18.8865 6.34318 17.8065C3.77318 16.1965 2.01318 13.0865 2.01318 9.7565Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionIcon);
export default __webpack_public_path__ + "static/media/ProtectionIcon.8347eb8a.svg";
export { ForwardRef as ReactComponent };